import { type CSSObject } from '@emotion/react'
import { Stack } from '@mui/material'
import React from 'react'

import theme from 'theme'

/**
 * MUI does not come with a TabPanel component
 * but this is what they use in their docs: https://mui.com/material-ui/react-tabs/#basic-tabs
 * @param children
 * @param currentTabIndex
 * @param tabIndex
 * @param other
 * @constructor
 */
export const TabPanel: React.FC<{
  children: React.ReactNode
  tabIndex: number
  currentTabIndex: number
  tabPanelCss?: CSSObject
}> = ({ children, tabIndex, currentTabIndex, tabPanelCss, ...rest }) => {
  return (
    <div
      aria-labelledby={`vertical-tab-${tabIndex}`}
      css={{ flex: '1 1 0' }}
      hidden={currentTabIndex !== tabIndex}
      id={`vertical-tabpanel-${tabIndex}`}
      role="tabpanel"
      {...rest}
    >
      {currentTabIndex === tabIndex && (
        <Stack css={tabPanelCss ?? { padding: theme.space[6] }}>
          {children}
        </Stack>
      )}
    </div>
  )
}
